import XIcon from "../assets/x.svg";

export default function TradeFormModal({ onClose, children }) {
 return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-lg shadow-lg relative">
        <button onClick={onClose} className="absolute top-6 right-6">
          <img src={XIcon} alt='close icon' className="h-8 w-8" />
        </button>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}